import { render, staticRenderFns } from "./AddEditComponent.vue?vue&type=template&id=ffa2bfea&scoped=true&"
import script from "./AddEditComponent.vue?vue&type=script&lang=js&"
export * from "./AddEditComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddEditComponent.vue?vue&type=style&index=0&id=ffa2bfea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa2bfea",
  null
  
)

export default component.exports